<template>
    <el-dialog :model-value="modelValue" title="勾选短信发送人员" @open="handleOpen" @close="handleCancel" width="850px">
        <el-row class="user-list" :gutter="20">
            <el-col :span="24">
                <Transition name="fade">
                    <el-form
                        v-if="formVisible"
                        :inline="true"
                        label-position="top"
                        class="search-form"
                        :model="search_data"
                        style="padding: 0"
                    >
                        <el-form-item label="名称">
                            <el-input v-model="search_data.name" clearable placeholder="请输入名称" style="width: 150px" />
                        </el-form-item>
                        <el-form-item label="角色">
                            <el-select v-model="search_data.role" placeholder="请选择角色" style="width: 150px" clearable>
                                <el-option
                                    v-for="(item, index) in roleOptions"
                                    :key="index.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="search_data.status" placeholder="请选择状态" style="width: 150px" clearable>
                                <el-option
                                    v-for="(item, index) in manStatusList"
                                    :key="index.vlaue"
                                    :label="item.name"
                                    :value="Number(item.value)"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                            <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                        </el-form-item>
                    </el-form>
                </Transition>

                <el-table
                    :data="table_data"
                    v-loading="tableLoading"
                    ref="multipleTableRef"
                    :row-key="(row) => row.id"
                    @select="handleSelectChange"
                    @select-all="handleSelectAllChange"
                    style="width: 100%"
                    border
                >
                    <el-table-column type="selection" width="45" :reserve-selection="true" />
                    <el-table-column label="序号" type="index" width="60" />
                    <el-table-column prop="username" label="用户名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column label="性别" prop="gender" width="80">
                        <template #default="{ row }">
                            <div>
                                {{ row.gender ? '男' : '女' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="online" label="状态">
                        <template #default="{ row }">
                            <span v-if="row.status" style="color: #67c23a">启用</span>
                            <span v-else style="color: #f56c6c">禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="role_name_lists" label="角色" show-overflow-tooltip></el-table-column>
                </el-table>
                <el-pagination
                    class="pagination"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data.page"
                    :page-sizes="[10, 20, 50]"
                    :page-size="search_data.page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
        <div style="display: flex; width: 97%; justify-content: end; margin-top: 20px">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="onAddClick">确定</el-button>
        </div>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, nextTick, onMounted, ref, watch } from 'vue'
import { getOperationLists } from '@/api/operation.js'
import { getRoleOptionLists } from '@/api/role.js'
import { checkRemoveMsgMan } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { Refresh, Search } from '@element-plus/icons'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true
    },
    levelItem: {
        require: true,
        type: Object
    }
})

const emits = defineEmits(['update:modelValue', 'updateManList'])

// 数据源
const search_data = ref({
    name: '',
    role: '',
    page: 1,
    page_size: 10,
    status: ''
})
const table_data = ref([])
const tableLoading = ref(false)
const total = ref(0)

const handleOpen = () => {
    console.log(props.selectMicrophoneId)
}

// 摄像头类型
const manStatusList = ref([
    { name: '启用', value: 1 },
    { name: '禁用', value: 0 }
])

// 设置添加摄像头回显数据
const multipleTableRef = ref()
const toggleSelection = (rows) => {
    nextTick(() => {
        if (rows) {
            table_data.value.forEach((item, index) => {
                rows.forEach((row, index) => {
                    if (item.id === row) {
                        multipleTableRef.value.toggleRowSelection(item, true)
                    }
                })
            })
        } else {
            multipleTableRef.value.clearSelection()
        }
    })
}

// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)
// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const result = await getOperationLists(search_data.value)
    table_data.value = result.lists
    total.value = result.total
    selectManList.value = Array.from(new Set([...selectManList.value]))
    nextTick(() => {
        toggleSelection(selectManList.value)
    })
    tableLoading.value = false
}

// 获取已选中列表
const getGroupCameraListsFnc = async () => {
    tableLoading.value = true
    let manList = [...props.levelItem?.message_lists]
    console.log(props.levelItem)
    if (!manList) {
        manList = []
    }
    selectManList.value = Array.from(new Set([...selectManList.value, ...manList.map((item) => item)]))
    console.log('selectManList', selectManList.value)
    nextTick(() => {
        toggleSelection(selectManList.value)
    })
    tableLoading.value = false
}

// watch(table_data, (val) => {
//     if (table_data.value.length) {
//         getGroupCameraListsFnc()
//     }
// })

const formDialogVisible = ref(false)
// const isForm = ref(false) // 是否是表单
const selectId = ref('') // 点中的运营单位id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}

// 角色选项列表
const roleOptions = ref([])

const getOptionDataFnc = async () => {
    roleOptions.value = await getRoleOptionLists()
}

// 被选择的摄像头列表
const selectManList = ref([])

// 选择摄像头
const handleSelectChange = (rows, data) => {
    if (!selectManList.value.find((item) => item === data.id)) {
        selectManList.value = Array.from(new Set([...selectManList.value, ...rows.map((item) => item.id)]))
    } else {
        selectManList.value = selectManList.value.filter((item) => {
            return item !== data.id
        })
    }
    nextTick(() => {
        toggleSelection(selectManList.value)
    })
}

// 全选
const handleSelectAllChange = (rows) => {
    // eslint-disable-next-line no-unused-vars
    let isTrue = null
    rows.forEach((i) => {
        table_data.value.forEach((item) => {
            if (item.id === i.id) {
                isTrue = true
            }
        })
    })
    if (isTrue) {
        selectManList.value = Array.from(new Set([...selectManList.value, ...rows.map((item) => item.id)]))
    } else {
        selectManList.value = filterHasSameArr(
            selectManList.value,
            table_data.value.map((item) => item.id)
        )
    }
}

const filterHasSameArr = (arr1, arr2) => {
    return arr1.filter((item) => {
        if (arr2.indexOf(item) < 0) {
            return item
        }
    })
}

// 批量添加摄像头
const onAddClick = async () => {
    try {
        await checkRemoveMsgMan(props.levelItem.id, { method: 'message_lists', data: [...selectManList.value] })
        emits('updateManList')
        emits('update:modelValue', false)
        ElMessage.success('添加成功')
    } catch (error) {}
}
const handleCancel = () => {
    emits('update:modelValue', false)
}
// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getOptionDataFnc()
    getTableData()
    getGroupCameraListsFnc()
})
</script>

<style lang="scss" scoped>
.title {
    font-size: 16px;
    margin-bottom: 8px;
}
.treeContainer {
    height: 500px;
}
</style>
